/**
 * useDataFreshness Hook
 * 
 * React Query hook for fetching data freshness status.
 * Migrated from seo-engine-webtools-customer-module
 */

import { useQuery } from '@tanstack/react-query';
import { getDataFreshness } from '@/services/customer/freshnessApi';
import { DataFreshnessResponse } from '@/types/customer';
import { useSiteStore } from '@/store/site.store';

export interface UseDataFreshnessOptions {
  siteId?: number;
  enabled?: boolean;
  refetchInterval?: number;
}

export function useDataFreshness(options: UseDataFreshnessOptions = {}) {
  const selectedSite = useSiteStore((state) => state.selectedSite);
  const siteId = options.siteId ?? selectedSite?.id ?? 1;

  return useQuery<DataFreshnessResponse, Error>({
    queryKey: ['customer-data-freshness', siteId],
    queryFn: () => getDataFreshness(siteId),
    enabled: options.enabled !== false,
    staleTime: 1 * 60 * 1000, // 1 minute
    refetchInterval: options.refetchInterval,
  });
}

export default useDataFreshness;
